var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "Modal",
        {
          staticClass: "page-modal",
          attrs: {
            width: "50%",
            "mask-closable": false,
            "footer-hide": true,
            title: _vm.$t("house.input"),
            "class-name": "vertical-center-modal",
          },
          on: { "on-cancel": _vm.handlerClose },
          model: {
            value: _vm.dialogVisible,
            callback: function ($$v) {
              _vm.dialogVisible = $$v
            },
            expression: "dialogVisible",
          },
        },
        [
          _c(
            "div",
            { staticClass: "step-box" },
            [
              _c(
                "Steps",
                {
                  staticClass: "margin-bottom-20",
                  attrs: { current: 1, status: "process" },
                },
                [
                  _c("Step", {
                    attrs: {
                      title: _vm.$t("house.importTip"),
                      content: _vm.$t("house.successFile"),
                    },
                  }),
                  _c("Step", {
                    attrs: {
                      title: _vm.$t("house.importTip1"),
                      content: _vm.$t("house.picContent"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "cir-box" }, [
            _c(
              "div",
              { staticClass: "cir-margin-left" },
              [
                _c(
                  "i-circle",
                  {
                    attrs: {
                      percent: 100,
                      "stroke-color": "#5cb85c",
                      "trail-width": 4,
                      "stroke-width": 5,
                      size: 200,
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "import-cir" },
                      [
                        _c("Icon", {
                          staticStyle: { color: "#5cb85c" },
                          attrs: { type: "ios-checkmark", size: "60" },
                        }),
                        _c("span", [_vm._v(_vm._s("100%"))]),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "cir-margin-right" },
              [
                _c(
                  "i-circle",
                  {
                    attrs: {
                      percent: 0,
                      "stroke-color": "#5cb85c",
                      "trail-width": 4,
                      "stroke-width": 5,
                      size: 200,
                    },
                  },
                  [
                    _c("div", { staticClass: "import-cir" }, [
                      _c("span", { staticClass: "cir-span" }, [
                        _vm._v(_vm._s(_vm.picNum)),
                      ]),
                    ]),
                  ]
                ),
                _c("form", { attrs: { id: "uploadImg" } }, [
                  _c(
                    "div",
                    { staticClass: "form-box margin-bottom-20 cir-btn" },
                    [
                      _c(
                        "Button",
                        { staticClass: "file", attrs: { type: "primary" } },
                        [
                          _vm._v(_vm._s(_vm.$t("house.upLoadBtn")) + " "),
                          _c("input", {
                            attrs: {
                              id: "file-uploader",
                              type: "file",
                              name: "facePic",
                              accept: ".jpg,.jpeg",
                              multiple: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.showPic($event)
                              },
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
      _c("div", { staticClass: "content_win" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }